module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section06_02_american-village-3b9e747db675241fe4900e30f9faaaa3.jpg";